import { NgReduxRouter, NgReduxRouterModule } from "@angular-redux/router";
import { DevToolsExtension, NgRedux, NgReduxModule } from "@angular-redux/store";
import { NgModule } from "@angular/core";
import { combineReducers } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { ContactEpics } from "../../+authenticated/+customer-master/customer-detail/contacts-v2/epics/contact-epics";
import { ContactService } from "../../+authenticated/+customer-master/customer-detail/contacts-v2/services/contact-service";
import { CustomerEpics } from "../../+authenticated/+customer-master/customer-detail/epics/customer-epics";
import { CustomerService } from "../../+authenticated/+customer-master/customer-detail/services/customer-service";
import { AvailEpisodesService } from "../../+authenticated/deal-terms/services/avail-episodes-service";
import { GlobalMessageActions } from "../../+authenticated/global-message/actions/global-message-actions";
import { environment as env } from "../../../environments/configs";
import { AuthModule } from "../auth/auth.module";
import { AuthService } from "../auth/auth.service";
import { genericRequestProvider } from "../graphql/generic-requests.service";
import { SharedModule } from "../shared.module";
import { NSAngular } from "../types";
import { ImmutableRedux } from "./immutable-redux.service";
import { ReduxRequestsMap } from "./redux-requests-map.service";
import { RootEpics } from "./root.epics";
import { allReducers } from "./root.reducer";

export const STORE_MODULE_IMPORTS: NSAngular.Import[] = [
    NgReduxModule,
    NgReduxRouterModule,
    AuthModule,
    SharedModule,
];

export const STORE_MODULE_PROVIDERS: NSAngular.Provider[] = [
    ImmutableRedux,
    ReduxRequestsMap,
    ...genericRequestProvider,
    RootEpics,
    GlobalMessageActions,
    CustomerEpics,
    CustomerService,
    ContactEpics,
    ContactService,
    AvailEpisodesService,
];

export const STORE_MODULE_DECLARATIONS: NSAngular.Declaration[] = [];

@NgModule({
    declarations: STORE_MODULE_DECLARATIONS,
    imports: STORE_MODULE_IMPORTS,
    providers: STORE_MODULE_PROVIDERS,
})
export class StoreModule {
    constructor(ngRedux: NgRedux<object>,
                ngReduxRouter: NgReduxRouter,
                devTools: DevToolsExtension,
                auth: AuthService,
                rootEpics: RootEpics,
                ) {
        const epicMiddleware = createEpicMiddleware();
        const rootReducer: any = combineReducers(allReducers);
        const enhancers: any[] = [];
        if (env.production === false && devTools.isEnabled()) {
            enhancers.push(devTools.enhancer());
        }
        ngRedux.configureStore(rootReducer, {}, [epicMiddleware], enhancers);
        epicMiddleware.run(rootEpics.createEpics());
        ngReduxRouter.initialize();
    }
}
